/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as SelectOutputYoutubeImport } from './routes/select-output/youtube'
import { Route as ExceptionNotifyImport } from './routes/exception/notify'
import { Route as ExceptionEventIdImport } from './routes/exception/$eventId'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index/route'
import { Route as AuthenticatedAddOutputIndexImport } from './routes/_authenticated.add-output/index'
import { Route as AuthTwitchCallbackImport } from './routes/auth/twitch/callback'
import { Route as AuthTiktokCreatorIneligibilityNoticeImport } from './routes/auth/tiktok/creator-ineligibility-notice'
import { Route as AuthTiktokCallbackImport } from './routes/auth/tiktok/callback'
import { Route as AuthProviderSuccessImport } from './routes/auth/$provider.success'
import { Route as AuthProviderPreAuthImport } from './routes/auth/$provider.pre-auth'
import { Route as AuthProviderErrorImport } from './routes/auth/$provider.error'
import { Route as AuthenticatedSettingsLayoutImport } from './routes/_authenticated.settings/_layout'
import { Route as AuthenticatedOnboardingEnsureVersionImport } from './routes/_authenticated.onboarding/_ensure-version'
import { Route as AuthenticatedCanvasesNewImport } from './routes/_authenticated.canvases/new'
import { Route as AuthenticatedOnboardingGettingStartedRouteImport } from './routes/_authenticated.onboarding/getting-started/route'
import { Route as AuthenticatedCanvasesCanvasIdIndexImport } from './routes/_authenticated.canvases/$canvasId/index'
import { Route as AuthConnectProviderPreAuthImport } from './routes/auth/connect/$provider.pre-auth'
import { Route as AuthConnectProviderCallbackImport } from './routes/auth/connect/$provider.callback'
import { Route as AuthenticatedOnboardingSetupMultistreamingLayoutImport } from './routes/_authenticated.onboarding/setup-multistreaming/_layout'
import { Route as AuthenticatedOnboardingNewSetupLayoutImport } from './routes/_authenticated.onboarding/new-setup/_layout'
import { Route as AuthenticatedCanvasesCanvasIdRemoveRouteImport } from './routes/_authenticated.canvases/$canvasId/remove/route'
import { Route as AuthenticatedOnboardingEnsureVersionIndexRouteImport } from './routes/_authenticated.onboarding/_ensure-version.index/route'
import { Route as AuthenticatedSettingsLayoutOutputsSettingsIndexImport } from './routes/_authenticated.settings._layout.outputs-settings/index'
import { Route as AuthenticatedSettingsLayoutBroadcastSettingsIndexImport } from './routes/_authenticated.settings._layout.broadcast-settings/index'
import { Route as AuthenticatedSettingsLayoutCanvasIdIndexImport } from './routes/_authenticated.settings._layout.$canvasId/index'
import { Route as AuthenticatedOnboardingSetupMultistreamingLayoutIndexImport } from './routes/_authenticated.onboarding/setup-multistreaming/_layout.index'
import { Route as AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexImport } from './routes/_authenticated.onboarding/_ensure-version.auto-determine-flow/index'
import { Route as AuthenticatedOnboardingSetupMultistreamingLayoutSuccessImport } from './routes/_authenticated.onboarding/setup-multistreaming/_layout.success'
import { Route as AuthenticatedOnboardingSetupMultistreamingLayoutFinishImport } from './routes/_authenticated.onboarding/setup-multistreaming/_layout.finish'
import { Route as AuthenticatedOnboardingSetupMultistreamingLayoutConnectImport } from './routes/_authenticated.onboarding/setup-multistreaming/_layout.connect'
import { Route as AuthenticatedCanvasesCanvasIdSceneIdRemoveImport } from './routes/_authenticated.canvases/$canvasId/$sceneId.remove'
import { Route as AuthenticatedOnboardingNewSetupLayoutIndexRouteImport } from './routes/_authenticated.onboarding/new-setup/_layout.index/route'
import { Route as AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexImport } from './routes/_authenticated.onboarding/new-setup/_layout.setup-display-capture/index'
import { Route as AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexImport } from './routes/_authenticated.onboarding/new-setup/_layout.setup-complete/index'
import { Route as AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexImport } from './routes/_authenticated.onboarding/new-setup/_layout.setup-alerts/index'
import { Route as AuthenticatedCanvasesCanvasIdNewSceneIndexImport } from './routes/_authenticated.canvases/$canvasId/new/scene/index'
import { Route as AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassImport } from './routes/_authenticated.canvases/$canvasId/new/source/$sceneId.$sourceClass'

// Create Virtual Routes

const AuthenticatedSettingsImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedOnboardingImport = createFileRoute(
  '/_authenticated/onboarding',
)()
const ObsModulesWarningIndexLazyImport = createFileRoute(
  '/obs-modules-warning/',
)()
const AuthLoginLazyImport = createFileRoute('/auth/login')()
const AuthenticatedOnboardingSetupMultistreamingImport = createFileRoute(
  '/_authenticated/onboarding/setup-multistreaming',
)()
const AuthenticatedOnboardingNewSetupImport = createFileRoute(
  '/_authenticated/onboarding/new-setup',
)()
const AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyImport =
  createFileRoute('/_authenticated/settings/_layout/create-first-canvas/')()

// Create/Update Routes

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSettingsRoute = AuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOnboardingRoute = AuthenticatedOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const ObsModulesWarningIndexLazyRoute = ObsModulesWarningIndexLazyImport.update(
  {
    id: '/obs-modules-warning/',
    path: '/obs-modules-warning/',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/obs-modules-warning/index.lazy').then((d) => d.Route),
)

const AuthLoginLazyRoute = AuthLoginLazyImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/auth/login.lazy').then((d) => d.Route))

const SelectOutputYoutubeRoute = SelectOutputYoutubeImport.update({
  id: '/select-output/youtube',
  path: '/select-output/youtube',
  getParentRoute: () => rootRoute,
} as any)

const ExceptionNotifyRoute = ExceptionNotifyImport.update({
  id: '/exception/notify',
  path: '/exception/notify',
  getParentRoute: () => rootRoute,
} as any)

const ExceptionEventIdRoute = ExceptionEventIdImport.update({
  id: '/exception/$eventId',
  path: '/exception/$eventId',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRouteRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated.index/route.lazy').then((d) => d.Route),
)

const AuthenticatedOnboardingSetupMultistreamingRoute =
  AuthenticatedOnboardingSetupMultistreamingImport.update({
    id: '/setup-multistreaming',
    path: '/setup-multistreaming',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedOnboardingNewSetupRoute =
  AuthenticatedOnboardingNewSetupImport.update({
    id: '/new-setup',
    path: '/new-setup',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedAddOutputIndexRoute =
  AuthenticatedAddOutputIndexImport.update({
    id: '/add-output/',
    path: '/add-output/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthTwitchCallbackRoute = AuthTwitchCallbackImport.update({
  id: '/auth/twitch/callback',
  path: '/auth/twitch/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthTiktokCreatorIneligibilityNoticeRoute =
  AuthTiktokCreatorIneligibilityNoticeImport.update({
    id: '/auth/tiktok/creator-ineligibility-notice',
    path: '/auth/tiktok/creator-ineligibility-notice',
    getParentRoute: () => rootRoute,
  } as any)

const AuthTiktokCallbackRoute = AuthTiktokCallbackImport.update({
  id: '/auth/tiktok/callback',
  path: '/auth/tiktok/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthProviderSuccessRoute = AuthProviderSuccessImport.update({
  id: '/auth/$provider/success',
  path: '/auth/$provider/success',
  getParentRoute: () => rootRoute,
} as any)

const AuthProviderPreAuthRoute = AuthProviderPreAuthImport.update({
  id: '/auth/$provider/pre-auth',
  path: '/auth/$provider/pre-auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthProviderErrorRoute = AuthProviderErrorImport.update({
  id: '/auth/$provider/error',
  path: '/auth/$provider/error',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSettingsLayoutRoute =
  AuthenticatedSettingsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)

const AuthenticatedOnboardingEnsureVersionRoute =
  AuthenticatedOnboardingEnsureVersionImport.update({
    id: '/_ensure-version',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedCanvasesNewRoute = AuthenticatedCanvasesNewImport.update({
  id: '/canvases/new',
  path: '/canvases/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOnboardingGettingStartedRouteRoute =
  AuthenticatedOnboardingGettingStartedRouteImport.update({
    id: '/onboarding/getting-started',
    path: '/onboarding/getting-started',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedCanvasesCanvasIdIndexRoute =
  AuthenticatedCanvasesCanvasIdIndexImport.update({
    id: '/canvases/$canvasId/',
    path: '/canvases/$canvasId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated.canvases/$canvasId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthConnectProviderPreAuthRoute = AuthConnectProviderPreAuthImport.update(
  {
    id: '/auth/connect/$provider/pre-auth',
    path: '/auth/connect/$provider/pre-auth',
    getParentRoute: () => rootRoute,
  } as any,
)

const AuthConnectProviderCallbackRoute =
  AuthConnectProviderCallbackImport.update({
    id: '/auth/connect/$provider/callback',
    path: '/auth/connect/$provider/callback',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedOnboardingSetupMultistreamingLayoutRoute =
  AuthenticatedOnboardingSetupMultistreamingLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedOnboardingSetupMultistreamingRoute,
  } as any)

const AuthenticatedOnboardingNewSetupLayoutRoute =
  AuthenticatedOnboardingNewSetupLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthenticatedOnboardingNewSetupRoute,
  } as any)

const AuthenticatedCanvasesCanvasIdRemoveRouteRoute =
  AuthenticatedCanvasesCanvasIdRemoveRouteImport.update({
    id: '/canvases/$canvasId/remove',
    path: '/canvases/$canvasId/remove',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated.canvases/$canvasId/remove/route.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticatedOnboardingEnsureVersionIndexRouteRoute =
  AuthenticatedOnboardingEnsureVersionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOnboardingEnsureVersionRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.onboarding/_ensure-version.index/route.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute =
  AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyImport.update({
    id: '/create-first-canvas/',
    path: '/create-first-canvas/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.settings._layout.create-first-canvas/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedSettingsLayoutOutputsSettingsIndexRoute =
  AuthenticatedSettingsLayoutOutputsSettingsIndexImport.update({
    id: '/outputs-settings/',
    path: '/outputs-settings/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)

const AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute =
  AuthenticatedSettingsLayoutBroadcastSettingsIndexImport.update({
    id: '/broadcast-settings/',
    path: '/broadcast-settings/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any)

const AuthenticatedSettingsLayoutCanvasIdIndexRoute =
  AuthenticatedSettingsLayoutCanvasIdIndexImport.update({
    id: '/$canvasId/',
    path: '/$canvasId/',
    getParentRoute: () => AuthenticatedSettingsLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.settings._layout.$canvasId/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute =
  AuthenticatedOnboardingSetupMultistreamingLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOnboardingSetupMultistreamingLayoutRoute,
  } as any)

const AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute =
  AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexImport.update({
    id: '/auto-determine-flow/',
    path: '/auto-determine-flow/',
    getParentRoute: () => AuthenticatedOnboardingEnsureVersionRoute,
  } as any)

const AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute =
  AuthenticatedOnboardingSetupMultistreamingLayoutSuccessImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedOnboardingSetupMultistreamingLayoutRoute,
  } as any)

const AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute =
  AuthenticatedOnboardingSetupMultistreamingLayoutFinishImport.update({
    id: '/finish',
    path: '/finish',
    getParentRoute: () => AuthenticatedOnboardingSetupMultistreamingLayoutRoute,
  } as any)

const AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute =
  AuthenticatedOnboardingSetupMultistreamingLayoutConnectImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => AuthenticatedOnboardingSetupMultistreamingLayoutRoute,
  } as any)

const AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute =
  AuthenticatedCanvasesCanvasIdSceneIdRemoveImport.update({
    id: '/canvases/$canvasId/$sceneId/remove',
    path: '/canvases/$canvasId/$sceneId/remove',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute =
  AuthenticatedOnboardingNewSetupLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOnboardingNewSetupLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.onboarding/new-setup/_layout.index/route.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute =
  AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexImport.update({
    id: '/setup-display-capture/',
    path: '/setup-display-capture/',
    getParentRoute: () => AuthenticatedOnboardingNewSetupLayoutRoute,
  } as any)

const AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute =
  AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexImport.update({
    id: '/setup-complete/',
    path: '/setup-complete/',
    getParentRoute: () => AuthenticatedOnboardingNewSetupLayoutRoute,
  } as any)

const AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute =
  AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexImport.update({
    id: '/setup-alerts/',
    path: '/setup-alerts/',
    getParentRoute: () => AuthenticatedOnboardingNewSetupLayoutRoute,
  } as any)

const AuthenticatedCanvasesCanvasIdNewSceneIndexRoute =
  AuthenticatedCanvasesCanvasIdNewSceneIndexImport.update({
    id: '/canvases/$canvasId/new/scene/',
    path: '/canvases/$canvasId/new/scene/',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.canvases/$canvasId/new/scene/index.lazy'
    ).then((d) => d.Route),
  )

const AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute =
  AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassImport.update({
    id: '/canvases/$canvasId/new/source/$sceneId/$sourceClass',
    path: '/canvases/$canvasId/new/source/$sceneId/$sourceClass',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated.canvases/$canvasId/new/source/$sceneId.$sourceClass.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/exception/$eventId': {
      id: '/exception/$eventId'
      path: '/exception/$eventId'
      fullPath: '/exception/$eventId'
      preLoaderRoute: typeof ExceptionEventIdImport
      parentRoute: typeof rootRoute
    }
    '/exception/notify': {
      id: '/exception/notify'
      path: '/exception/notify'
      fullPath: '/exception/notify'
      preLoaderRoute: typeof ExceptionNotifyImport
      parentRoute: typeof rootRoute
    }
    '/select-output/youtube': {
      id: '/select-output/youtube'
      path: '/select-output/youtube'
      fullPath: '/select-output/youtube'
      preLoaderRoute: typeof SelectOutputYoutubeImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyImport
      parentRoute: typeof rootRoute
    }
    '/obs-modules-warning/': {
      id: '/obs-modules-warning/'
      path: '/obs-modules-warning'
      fullPath: '/obs-modules-warning'
      preLoaderRoute: typeof ObsModulesWarningIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/onboarding/getting-started': {
      id: '/_authenticated/onboarding/getting-started'
      path: '/onboarding/getting-started'
      fullPath: '/onboarding/getting-started'
      preLoaderRoute: typeof AuthenticatedOnboardingGettingStartedRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/canvases/new': {
      id: '/_authenticated/canvases/new'
      path: '/canvases/new'
      fullPath: '/canvases/new'
      preLoaderRoute: typeof AuthenticatedCanvasesNewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/_ensure-version': {
      id: '/_authenticated/onboarding/_ensure-version'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingEnsureVersionImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/_layout': {
      id: '/_authenticated/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/auth/$provider/error': {
      id: '/auth/$provider/error'
      path: '/auth/$provider/error'
      fullPath: '/auth/$provider/error'
      preLoaderRoute: typeof AuthProviderErrorImport
      parentRoute: typeof rootRoute
    }
    '/auth/$provider/pre-auth': {
      id: '/auth/$provider/pre-auth'
      path: '/auth/$provider/pre-auth'
      fullPath: '/auth/$provider/pre-auth'
      preLoaderRoute: typeof AuthProviderPreAuthImport
      parentRoute: typeof rootRoute
    }
    '/auth/$provider/success': {
      id: '/auth/$provider/success'
      path: '/auth/$provider/success'
      fullPath: '/auth/$provider/success'
      preLoaderRoute: typeof AuthProviderSuccessImport
      parentRoute: typeof rootRoute
    }
    '/auth/tiktok/callback': {
      id: '/auth/tiktok/callback'
      path: '/auth/tiktok/callback'
      fullPath: '/auth/tiktok/callback'
      preLoaderRoute: typeof AuthTiktokCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/tiktok/creator-ineligibility-notice': {
      id: '/auth/tiktok/creator-ineligibility-notice'
      path: '/auth/tiktok/creator-ineligibility-notice'
      fullPath: '/auth/tiktok/creator-ineligibility-notice'
      preLoaderRoute: typeof AuthTiktokCreatorIneligibilityNoticeImport
      parentRoute: typeof rootRoute
    }
    '/auth/twitch/callback': {
      id: '/auth/twitch/callback'
      path: '/auth/twitch/callback'
      fullPath: '/auth/twitch/callback'
      preLoaderRoute: typeof AuthTwitchCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/add-output/': {
      id: '/_authenticated/add-output/'
      path: '/add-output'
      fullPath: '/add-output'
      preLoaderRoute: typeof AuthenticatedAddOutputIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/_ensure-version/': {
      id: '/_authenticated/onboarding/_ensure-version/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingEnsureVersionIndexRouteImport
      parentRoute: typeof AuthenticatedOnboardingEnsureVersionImport
    }
    '/_authenticated/canvases/$canvasId/remove': {
      id: '/_authenticated/canvases/$canvasId/remove'
      path: '/canvases/$canvasId/remove'
      fullPath: '/canvases/$canvasId/remove'
      preLoaderRoute: typeof AuthenticatedCanvasesCanvasIdRemoveRouteImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/new-setup': {
      id: '/_authenticated/onboarding/new-setup'
      path: '/new-setup'
      fullPath: '/onboarding/new-setup'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/onboarding/new-setup/_layout': {
      id: '/_authenticated/onboarding/new-setup/_layout'
      path: '/new-setup'
      fullPath: '/onboarding/new-setup'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupLayoutImport
      parentRoute: typeof AuthenticatedOnboardingNewSetupRoute
    }
    '/_authenticated/onboarding/setup-multistreaming': {
      id: '/_authenticated/onboarding/setup-multistreaming'
      path: '/setup-multistreaming'
      fullPath: '/onboarding/setup-multistreaming'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/onboarding/setup-multistreaming/_layout': {
      id: '/_authenticated/onboarding/setup-multistreaming/_layout'
      path: '/setup-multistreaming'
      fullPath: '/onboarding/setup-multistreaming'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutImport
      parentRoute: typeof AuthenticatedOnboardingSetupMultistreamingRoute
    }
    '/auth/connect/$provider/callback': {
      id: '/auth/connect/$provider/callback'
      path: '/auth/connect/$provider/callback'
      fullPath: '/auth/connect/$provider/callback'
      preLoaderRoute: typeof AuthConnectProviderCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/connect/$provider/pre-auth': {
      id: '/auth/connect/$provider/pre-auth'
      path: '/auth/connect/$provider/pre-auth'
      fullPath: '/auth/connect/$provider/pre-auth'
      preLoaderRoute: typeof AuthConnectProviderPreAuthImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/canvases/$canvasId/': {
      id: '/_authenticated/canvases/$canvasId/'
      path: '/canvases/$canvasId'
      fullPath: '/canvases/$canvasId'
      preLoaderRoute: typeof AuthenticatedCanvasesCanvasIdIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/new-setup/_layout/': {
      id: '/_authenticated/onboarding/new-setup/_layout/'
      path: '/'
      fullPath: '/onboarding/new-setup/'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupLayoutIndexRouteImport
      parentRoute: typeof AuthenticatedOnboardingNewSetupLayoutImport
    }
    '/_authenticated/canvases/$canvasId/$sceneId/remove': {
      id: '/_authenticated/canvases/$canvasId/$sceneId/remove'
      path: '/canvases/$canvasId/$sceneId/remove'
      fullPath: '/canvases/$canvasId/$sceneId/remove'
      preLoaderRoute: typeof AuthenticatedCanvasesCanvasIdSceneIdRemoveImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/setup-multistreaming/_layout/connect': {
      id: '/_authenticated/onboarding/setup-multistreaming/_layout/connect'
      path: '/connect'
      fullPath: '/onboarding/setup-multistreaming/connect'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutConnectImport
      parentRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutImport
    }
    '/_authenticated/onboarding/setup-multistreaming/_layout/finish': {
      id: '/_authenticated/onboarding/setup-multistreaming/_layout/finish'
      path: '/finish'
      fullPath: '/onboarding/setup-multistreaming/finish'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutFinishImport
      parentRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutImport
    }
    '/_authenticated/onboarding/setup-multistreaming/_layout/success': {
      id: '/_authenticated/onboarding/setup-multistreaming/_layout/success'
      path: '/success'
      fullPath: '/onboarding/setup-multistreaming/success'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutSuccessImport
      parentRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutImport
    }
    '/_authenticated/onboarding/_ensure-version/auto-determine-flow/': {
      id: '/_authenticated/onboarding/_ensure-version/auto-determine-flow/'
      path: '/auto-determine-flow'
      fullPath: '/onboarding/auto-determine-flow'
      preLoaderRoute: typeof AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexImport
      parentRoute: typeof AuthenticatedOnboardingEnsureVersionImport
    }
    '/_authenticated/onboarding/setup-multistreaming/_layout/': {
      id: '/_authenticated/onboarding/setup-multistreaming/_layout/'
      path: '/'
      fullPath: '/onboarding/setup-multistreaming/'
      preLoaderRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutIndexImport
      parentRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutImport
    }
    '/_authenticated/settings/_layout/$canvasId/': {
      id: '/_authenticated/settings/_layout/$canvasId/'
      path: '/$canvasId'
      fullPath: '/settings/$canvasId'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCanvasIdIndexImport
      parentRoute: typeof AuthenticatedSettingsLayoutImport
    }
    '/_authenticated/settings/_layout/broadcast-settings/': {
      id: '/_authenticated/settings/_layout/broadcast-settings/'
      path: '/broadcast-settings'
      fullPath: '/settings/broadcast-settings'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutBroadcastSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsLayoutImport
    }
    '/_authenticated/settings/_layout/outputs-settings/': {
      id: '/_authenticated/settings/_layout/outputs-settings/'
      path: '/outputs-settings'
      fullPath: '/settings/outputs-settings'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutOutputsSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsLayoutImport
    }
    '/_authenticated/settings/_layout/create-first-canvas/': {
      id: '/_authenticated/settings/_layout/create-first-canvas/'
      path: '/create-first-canvas'
      fullPath: '/settings/create-first-canvas'
      preLoaderRoute: typeof AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyImport
      parentRoute: typeof AuthenticatedSettingsLayoutImport
    }
    '/_authenticated/canvases/$canvasId/new/scene/': {
      id: '/_authenticated/canvases/$canvasId/new/scene/'
      path: '/canvases/$canvasId/new/scene'
      fullPath: '/canvases/$canvasId/new/scene'
      preLoaderRoute: typeof AuthenticatedCanvasesCanvasIdNewSceneIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/onboarding/new-setup/_layout/setup-alerts/': {
      id: '/_authenticated/onboarding/new-setup/_layout/setup-alerts/'
      path: '/setup-alerts'
      fullPath: '/onboarding/new-setup/setup-alerts'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexImport
      parentRoute: typeof AuthenticatedOnboardingNewSetupLayoutImport
    }
    '/_authenticated/onboarding/new-setup/_layout/setup-complete/': {
      id: '/_authenticated/onboarding/new-setup/_layout/setup-complete/'
      path: '/setup-complete'
      fullPath: '/onboarding/new-setup/setup-complete'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexImport
      parentRoute: typeof AuthenticatedOnboardingNewSetupLayoutImport
    }
    '/_authenticated/onboarding/new-setup/_layout/setup-display-capture/': {
      id: '/_authenticated/onboarding/new-setup/_layout/setup-display-capture/'
      path: '/setup-display-capture'
      fullPath: '/onboarding/new-setup/setup-display-capture'
      preLoaderRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexImport
      parentRoute: typeof AuthenticatedOnboardingNewSetupLayoutImport
    }
    '/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass': {
      id: '/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass'
      path: '/canvases/$canvasId/new/source/$sceneId/$sourceClass'
      fullPath: '/canvases/$canvasId/new/source/$sceneId/$sourceClass'
      preLoaderRoute: typeof AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedOnboardingEnsureVersionRouteChildren {
  AuthenticatedOnboardingEnsureVersionIndexRouteRoute: typeof AuthenticatedOnboardingEnsureVersionIndexRouteRoute
  AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute: typeof AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute
}

const AuthenticatedOnboardingEnsureVersionRouteChildren: AuthenticatedOnboardingEnsureVersionRouteChildren =
  {
    AuthenticatedOnboardingEnsureVersionIndexRouteRoute:
      AuthenticatedOnboardingEnsureVersionIndexRouteRoute,
    AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute:
      AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute,
  }

const AuthenticatedOnboardingEnsureVersionRouteWithChildren =
  AuthenticatedOnboardingEnsureVersionRoute._addFileChildren(
    AuthenticatedOnboardingEnsureVersionRouteChildren,
  )

interface AuthenticatedOnboardingNewSetupLayoutRouteChildren {
  AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute: typeof AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute
  AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute
  AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute
  AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute: typeof AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute
}

const AuthenticatedOnboardingNewSetupLayoutRouteChildren: AuthenticatedOnboardingNewSetupLayoutRouteChildren =
  {
    AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute:
      AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute,
    AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute:
      AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute,
    AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute:
      AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute,
    AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute:
      AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute,
  }

const AuthenticatedOnboardingNewSetupLayoutRouteWithChildren =
  AuthenticatedOnboardingNewSetupLayoutRoute._addFileChildren(
    AuthenticatedOnboardingNewSetupLayoutRouteChildren,
  )

interface AuthenticatedOnboardingNewSetupRouteChildren {
  AuthenticatedOnboardingNewSetupLayoutRoute: typeof AuthenticatedOnboardingNewSetupLayoutRouteWithChildren
}

const AuthenticatedOnboardingNewSetupRouteChildren: AuthenticatedOnboardingNewSetupRouteChildren =
  {
    AuthenticatedOnboardingNewSetupLayoutRoute:
      AuthenticatedOnboardingNewSetupLayoutRouteWithChildren,
  }

const AuthenticatedOnboardingNewSetupRouteWithChildren =
  AuthenticatedOnboardingNewSetupRoute._addFileChildren(
    AuthenticatedOnboardingNewSetupRouteChildren,
  )

interface AuthenticatedOnboardingSetupMultistreamingLayoutRouteChildren {
  AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute
  AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute
  AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute
  AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute
}

const AuthenticatedOnboardingSetupMultistreamingLayoutRouteChildren: AuthenticatedOnboardingSetupMultistreamingLayoutRouteChildren =
  {
    AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute:
      AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute,
    AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute:
      AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute,
    AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute:
      AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute,
    AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute:
      AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute,
  }

const AuthenticatedOnboardingSetupMultistreamingLayoutRouteWithChildren =
  AuthenticatedOnboardingSetupMultistreamingLayoutRoute._addFileChildren(
    AuthenticatedOnboardingSetupMultistreamingLayoutRouteChildren,
  )

interface AuthenticatedOnboardingSetupMultistreamingRouteChildren {
  AuthenticatedOnboardingSetupMultistreamingLayoutRoute: typeof AuthenticatedOnboardingSetupMultistreamingLayoutRouteWithChildren
}

const AuthenticatedOnboardingSetupMultistreamingRouteChildren: AuthenticatedOnboardingSetupMultistreamingRouteChildren =
  {
    AuthenticatedOnboardingSetupMultistreamingLayoutRoute:
      AuthenticatedOnboardingSetupMultistreamingLayoutRouteWithChildren,
  }

const AuthenticatedOnboardingSetupMultistreamingRouteWithChildren =
  AuthenticatedOnboardingSetupMultistreamingRoute._addFileChildren(
    AuthenticatedOnboardingSetupMultistreamingRouteChildren,
  )

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingEnsureVersionRoute: typeof AuthenticatedOnboardingEnsureVersionRouteWithChildren
  AuthenticatedOnboardingNewSetupRoute: typeof AuthenticatedOnboardingNewSetupRouteWithChildren
  AuthenticatedOnboardingSetupMultistreamingRoute: typeof AuthenticatedOnboardingSetupMultistreamingRouteWithChildren
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingEnsureVersionRoute:
      AuthenticatedOnboardingEnsureVersionRouteWithChildren,
    AuthenticatedOnboardingNewSetupRoute:
      AuthenticatedOnboardingNewSetupRouteWithChildren,
    AuthenticatedOnboardingSetupMultistreamingRoute:
      AuthenticatedOnboardingSetupMultistreamingRouteWithChildren,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedSettingsLayoutRouteChildren {
  AuthenticatedSettingsLayoutCanvasIdIndexRoute: typeof AuthenticatedSettingsLayoutCanvasIdIndexRoute
  AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute: typeof AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute
  AuthenticatedSettingsLayoutOutputsSettingsIndexRoute: typeof AuthenticatedSettingsLayoutOutputsSettingsIndexRoute
  AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute: typeof AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute
}

const AuthenticatedSettingsLayoutRouteChildren: AuthenticatedSettingsLayoutRouteChildren =
  {
    AuthenticatedSettingsLayoutCanvasIdIndexRoute:
      AuthenticatedSettingsLayoutCanvasIdIndexRoute,
    AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute:
      AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute,
    AuthenticatedSettingsLayoutOutputsSettingsIndexRoute:
      AuthenticatedSettingsLayoutOutputsSettingsIndexRoute,
    AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute:
      AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute,
  }

const AuthenticatedSettingsLayoutRouteWithChildren =
  AuthenticatedSettingsLayoutRoute._addFileChildren(
    AuthenticatedSettingsLayoutRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsLayoutRoute: typeof AuthenticatedSettingsLayoutRouteWithChildren
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsLayoutRoute:
    AuthenticatedSettingsLayoutRouteWithChildren,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRouteRoute: typeof AuthenticatedIndexRouteRoute
  AuthenticatedOnboardingGettingStartedRouteRoute: typeof AuthenticatedOnboardingGettingStartedRouteRoute
  AuthenticatedCanvasesNewRoute: typeof AuthenticatedCanvasesNewRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedAddOutputIndexRoute: typeof AuthenticatedAddOutputIndexRoute
  AuthenticatedCanvasesCanvasIdRemoveRouteRoute: typeof AuthenticatedCanvasesCanvasIdRemoveRouteRoute
  AuthenticatedCanvasesCanvasIdIndexRoute: typeof AuthenticatedCanvasesCanvasIdIndexRoute
  AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute: typeof AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute
  AuthenticatedCanvasesCanvasIdNewSceneIndexRoute: typeof AuthenticatedCanvasesCanvasIdNewSceneIndexRoute
  AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute: typeof AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRouteRoute: AuthenticatedIndexRouteRoute,
  AuthenticatedOnboardingGettingStartedRouteRoute:
    AuthenticatedOnboardingGettingStartedRouteRoute,
  AuthenticatedCanvasesNewRoute: AuthenticatedCanvasesNewRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedAddOutputIndexRoute: AuthenticatedAddOutputIndexRoute,
  AuthenticatedCanvasesCanvasIdRemoveRouteRoute:
    AuthenticatedCanvasesCanvasIdRemoveRouteRoute,
  AuthenticatedCanvasesCanvasIdIndexRoute:
    AuthenticatedCanvasesCanvasIdIndexRoute,
  AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute:
    AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute,
  AuthenticatedCanvasesCanvasIdNewSceneIndexRoute:
    AuthenticatedCanvasesCanvasIdNewSceneIndexRoute,
  AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute:
    AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/': typeof AuthenticatedIndexRouteRoute
  '/exception/$eventId': typeof ExceptionEventIdRoute
  '/exception/notify': typeof ExceptionNotifyRoute
  '/select-output/youtube': typeof SelectOutputYoutubeRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/obs-modules-warning': typeof ObsModulesWarningIndexLazyRoute
  '/onboarding/getting-started': typeof AuthenticatedOnboardingGettingStartedRouteRoute
  '/canvases/new': typeof AuthenticatedCanvasesNewRoute
  '/onboarding': typeof AuthenticatedOnboardingEnsureVersionRouteWithChildren
  '/settings': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/auth/$provider/error': typeof AuthProviderErrorRoute
  '/auth/$provider/pre-auth': typeof AuthProviderPreAuthRoute
  '/auth/$provider/success': typeof AuthProviderSuccessRoute
  '/auth/tiktok/callback': typeof AuthTiktokCallbackRoute
  '/auth/tiktok/creator-ineligibility-notice': typeof AuthTiktokCreatorIneligibilityNoticeRoute
  '/auth/twitch/callback': typeof AuthTwitchCallbackRoute
  '/add-output': typeof AuthenticatedAddOutputIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingEnsureVersionIndexRouteRoute
  '/canvases/$canvasId/remove': typeof AuthenticatedCanvasesCanvasIdRemoveRouteRoute
  '/onboarding/new-setup': typeof AuthenticatedOnboardingNewSetupLayoutRouteWithChildren
  '/onboarding/setup-multistreaming': typeof AuthenticatedOnboardingSetupMultistreamingLayoutRouteWithChildren
  '/auth/connect/$provider/callback': typeof AuthConnectProviderCallbackRoute
  '/auth/connect/$provider/pre-auth': typeof AuthConnectProviderPreAuthRoute
  '/canvases/$canvasId': typeof AuthenticatedCanvasesCanvasIdIndexRoute
  '/onboarding/new-setup/': typeof AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute
  '/canvases/$canvasId/$sceneId/remove': typeof AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute
  '/onboarding/setup-multistreaming/connect': typeof AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute
  '/onboarding/setup-multistreaming/finish': typeof AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute
  '/onboarding/setup-multistreaming/success': typeof AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute
  '/onboarding/auto-determine-flow': typeof AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute
  '/onboarding/setup-multistreaming/': typeof AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute
  '/settings/$canvasId': typeof AuthenticatedSettingsLayoutCanvasIdIndexRoute
  '/settings/broadcast-settings': typeof AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute
  '/settings/outputs-settings': typeof AuthenticatedSettingsLayoutOutputsSettingsIndexRoute
  '/settings/create-first-canvas': typeof AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute
  '/canvases/$canvasId/new/scene': typeof AuthenticatedCanvasesCanvasIdNewSceneIndexRoute
  '/onboarding/new-setup/setup-alerts': typeof AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute
  '/onboarding/new-setup/setup-complete': typeof AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute
  '/onboarding/new-setup/setup-display-capture': typeof AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute
  '/canvases/$canvasId/new/source/$sceneId/$sourceClass': typeof AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute
}

export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRouteRoute
  '/exception/$eventId': typeof ExceptionEventIdRoute
  '/exception/notify': typeof ExceptionNotifyRoute
  '/select-output/youtube': typeof SelectOutputYoutubeRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/obs-modules-warning': typeof ObsModulesWarningIndexLazyRoute
  '/onboarding/getting-started': typeof AuthenticatedOnboardingGettingStartedRouteRoute
  '/canvases/new': typeof AuthenticatedCanvasesNewRoute
  '/onboarding': typeof AuthenticatedOnboardingEnsureVersionIndexRouteRoute
  '/settings': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/auth/$provider/error': typeof AuthProviderErrorRoute
  '/auth/$provider/pre-auth': typeof AuthProviderPreAuthRoute
  '/auth/$provider/success': typeof AuthProviderSuccessRoute
  '/auth/tiktok/callback': typeof AuthTiktokCallbackRoute
  '/auth/tiktok/creator-ineligibility-notice': typeof AuthTiktokCreatorIneligibilityNoticeRoute
  '/auth/twitch/callback': typeof AuthTwitchCallbackRoute
  '/add-output': typeof AuthenticatedAddOutputIndexRoute
  '/canvases/$canvasId/remove': typeof AuthenticatedCanvasesCanvasIdRemoveRouteRoute
  '/onboarding/new-setup': typeof AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute
  '/onboarding/setup-multistreaming': typeof AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute
  '/auth/connect/$provider/callback': typeof AuthConnectProviderCallbackRoute
  '/auth/connect/$provider/pre-auth': typeof AuthConnectProviderPreAuthRoute
  '/canvases/$canvasId': typeof AuthenticatedCanvasesCanvasIdIndexRoute
  '/canvases/$canvasId/$sceneId/remove': typeof AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute
  '/onboarding/setup-multistreaming/connect': typeof AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute
  '/onboarding/setup-multistreaming/finish': typeof AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute
  '/onboarding/setup-multistreaming/success': typeof AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute
  '/onboarding/auto-determine-flow': typeof AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute
  '/settings/$canvasId': typeof AuthenticatedSettingsLayoutCanvasIdIndexRoute
  '/settings/broadcast-settings': typeof AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute
  '/settings/outputs-settings': typeof AuthenticatedSettingsLayoutOutputsSettingsIndexRoute
  '/settings/create-first-canvas': typeof AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute
  '/canvases/$canvasId/new/scene': typeof AuthenticatedCanvasesCanvasIdNewSceneIndexRoute
  '/onboarding/new-setup/setup-alerts': typeof AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute
  '/onboarding/new-setup/setup-complete': typeof AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute
  '/onboarding/new-setup/setup-display-capture': typeof AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute
  '/canvases/$canvasId/new/source/$sceneId/$sourceClass': typeof AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRouteRoute
  '/exception/$eventId': typeof ExceptionEventIdRoute
  '/exception/notify': typeof ExceptionNotifyRoute
  '/select-output/youtube': typeof SelectOutputYoutubeRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/obs-modules-warning/': typeof ObsModulesWarningIndexLazyRoute
  '/_authenticated/onboarding/getting-started': typeof AuthenticatedOnboardingGettingStartedRouteRoute
  '/_authenticated/canvases/new': typeof AuthenticatedCanvasesNewRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/_authenticated/onboarding/_ensure-version': typeof AuthenticatedOnboardingEnsureVersionRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/settings/_layout': typeof AuthenticatedSettingsLayoutRouteWithChildren
  '/auth/$provider/error': typeof AuthProviderErrorRoute
  '/auth/$provider/pre-auth': typeof AuthProviderPreAuthRoute
  '/auth/$provider/success': typeof AuthProviderSuccessRoute
  '/auth/tiktok/callback': typeof AuthTiktokCallbackRoute
  '/auth/tiktok/creator-ineligibility-notice': typeof AuthTiktokCreatorIneligibilityNoticeRoute
  '/auth/twitch/callback': typeof AuthTwitchCallbackRoute
  '/_authenticated/add-output/': typeof AuthenticatedAddOutputIndexRoute
  '/_authenticated/onboarding/_ensure-version/': typeof AuthenticatedOnboardingEnsureVersionIndexRouteRoute
  '/_authenticated/canvases/$canvasId/remove': typeof AuthenticatedCanvasesCanvasIdRemoveRouteRoute
  '/_authenticated/onboarding/new-setup': typeof AuthenticatedOnboardingNewSetupRouteWithChildren
  '/_authenticated/onboarding/new-setup/_layout': typeof AuthenticatedOnboardingNewSetupLayoutRouteWithChildren
  '/_authenticated/onboarding/setup-multistreaming': typeof AuthenticatedOnboardingSetupMultistreamingRouteWithChildren
  '/_authenticated/onboarding/setup-multistreaming/_layout': typeof AuthenticatedOnboardingSetupMultistreamingLayoutRouteWithChildren
  '/auth/connect/$provider/callback': typeof AuthConnectProviderCallbackRoute
  '/auth/connect/$provider/pre-auth': typeof AuthConnectProviderPreAuthRoute
  '/_authenticated/canvases/$canvasId/': typeof AuthenticatedCanvasesCanvasIdIndexRoute
  '/_authenticated/onboarding/new-setup/_layout/': typeof AuthenticatedOnboardingNewSetupLayoutIndexRouteRoute
  '/_authenticated/canvases/$canvasId/$sceneId/remove': typeof AuthenticatedCanvasesCanvasIdSceneIdRemoveRoute
  '/_authenticated/onboarding/setup-multistreaming/_layout/connect': typeof AuthenticatedOnboardingSetupMultistreamingLayoutConnectRoute
  '/_authenticated/onboarding/setup-multistreaming/_layout/finish': typeof AuthenticatedOnboardingSetupMultistreamingLayoutFinishRoute
  '/_authenticated/onboarding/setup-multistreaming/_layout/success': typeof AuthenticatedOnboardingSetupMultistreamingLayoutSuccessRoute
  '/_authenticated/onboarding/_ensure-version/auto-determine-flow/': typeof AuthenticatedOnboardingEnsureVersionAutoDetermineFlowIndexRoute
  '/_authenticated/onboarding/setup-multistreaming/_layout/': typeof AuthenticatedOnboardingSetupMultistreamingLayoutIndexRoute
  '/_authenticated/settings/_layout/$canvasId/': typeof AuthenticatedSettingsLayoutCanvasIdIndexRoute
  '/_authenticated/settings/_layout/broadcast-settings/': typeof AuthenticatedSettingsLayoutBroadcastSettingsIndexRoute
  '/_authenticated/settings/_layout/outputs-settings/': typeof AuthenticatedSettingsLayoutOutputsSettingsIndexRoute
  '/_authenticated/settings/_layout/create-first-canvas/': typeof AuthenticatedSettingsLayoutCreateFirstCanvasIndexLazyRoute
  '/_authenticated/canvases/$canvasId/new/scene/': typeof AuthenticatedCanvasesCanvasIdNewSceneIndexRoute
  '/_authenticated/onboarding/new-setup/_layout/setup-alerts/': typeof AuthenticatedOnboardingNewSetupLayoutSetupAlertsIndexRoute
  '/_authenticated/onboarding/new-setup/_layout/setup-complete/': typeof AuthenticatedOnboardingNewSetupLayoutSetupCompleteIndexRoute
  '/_authenticated/onboarding/new-setup/_layout/setup-display-capture/': typeof AuthenticatedOnboardingNewSetupLayoutSetupDisplayCaptureIndexRoute
  '/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass': typeof AuthenticatedCanvasesCanvasIdNewSourceSceneIdSourceClassRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/'
    | '/exception/$eventId'
    | '/exception/notify'
    | '/select-output/youtube'
    | '/auth/login'
    | '/obs-modules-warning'
    | '/onboarding/getting-started'
    | '/canvases/new'
    | '/onboarding'
    | '/settings'
    | '/auth/$provider/error'
    | '/auth/$provider/pre-auth'
    | '/auth/$provider/success'
    | '/auth/tiktok/callback'
    | '/auth/tiktok/creator-ineligibility-notice'
    | '/auth/twitch/callback'
    | '/add-output'
    | '/onboarding/'
    | '/canvases/$canvasId/remove'
    | '/onboarding/new-setup'
    | '/onboarding/setup-multistreaming'
    | '/auth/connect/$provider/callback'
    | '/auth/connect/$provider/pre-auth'
    | '/canvases/$canvasId'
    | '/onboarding/new-setup/'
    | '/canvases/$canvasId/$sceneId/remove'
    | '/onboarding/setup-multistreaming/connect'
    | '/onboarding/setup-multistreaming/finish'
    | '/onboarding/setup-multistreaming/success'
    | '/onboarding/auto-determine-flow'
    | '/onboarding/setup-multistreaming/'
    | '/settings/$canvasId'
    | '/settings/broadcast-settings'
    | '/settings/outputs-settings'
    | '/settings/create-first-canvas'
    | '/canvases/$canvasId/new/scene'
    | '/onboarding/new-setup/setup-alerts'
    | '/onboarding/new-setup/setup-complete'
    | '/onboarding/new-setup/setup-display-capture'
    | '/canvases/$canvasId/new/source/$sceneId/$sourceClass'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/exception/$eventId'
    | '/exception/notify'
    | '/select-output/youtube'
    | '/auth/login'
    | '/obs-modules-warning'
    | '/onboarding/getting-started'
    | '/canvases/new'
    | '/onboarding'
    | '/settings'
    | '/auth/$provider/error'
    | '/auth/$provider/pre-auth'
    | '/auth/$provider/success'
    | '/auth/tiktok/callback'
    | '/auth/tiktok/creator-ineligibility-notice'
    | '/auth/twitch/callback'
    | '/add-output'
    | '/canvases/$canvasId/remove'
    | '/onboarding/new-setup'
    | '/onboarding/setup-multistreaming'
    | '/auth/connect/$provider/callback'
    | '/auth/connect/$provider/pre-auth'
    | '/canvases/$canvasId'
    | '/canvases/$canvasId/$sceneId/remove'
    | '/onboarding/setup-multistreaming/connect'
    | '/onboarding/setup-multistreaming/finish'
    | '/onboarding/setup-multistreaming/success'
    | '/onboarding/auto-determine-flow'
    | '/settings/$canvasId'
    | '/settings/broadcast-settings'
    | '/settings/outputs-settings'
    | '/settings/create-first-canvas'
    | '/canvases/$canvasId/new/scene'
    | '/onboarding/new-setup/setup-alerts'
    | '/onboarding/new-setup/setup-complete'
    | '/onboarding/new-setup/setup-display-capture'
    | '/canvases/$canvasId/new/source/$sceneId/$sourceClass'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/'
    | '/exception/$eventId'
    | '/exception/notify'
    | '/select-output/youtube'
    | '/auth/login'
    | '/obs-modules-warning/'
    | '/_authenticated/onboarding/getting-started'
    | '/_authenticated/canvases/new'
    | '/_authenticated/onboarding'
    | '/_authenticated/onboarding/_ensure-version'
    | '/_authenticated/settings'
    | '/_authenticated/settings/_layout'
    | '/auth/$provider/error'
    | '/auth/$provider/pre-auth'
    | '/auth/$provider/success'
    | '/auth/tiktok/callback'
    | '/auth/tiktok/creator-ineligibility-notice'
    | '/auth/twitch/callback'
    | '/_authenticated/add-output/'
    | '/_authenticated/onboarding/_ensure-version/'
    | '/_authenticated/canvases/$canvasId/remove'
    | '/_authenticated/onboarding/new-setup'
    | '/_authenticated/onboarding/new-setup/_layout'
    | '/_authenticated/onboarding/setup-multistreaming'
    | '/_authenticated/onboarding/setup-multistreaming/_layout'
    | '/auth/connect/$provider/callback'
    | '/auth/connect/$provider/pre-auth'
    | '/_authenticated/canvases/$canvasId/'
    | '/_authenticated/onboarding/new-setup/_layout/'
    | '/_authenticated/canvases/$canvasId/$sceneId/remove'
    | '/_authenticated/onboarding/setup-multistreaming/_layout/connect'
    | '/_authenticated/onboarding/setup-multistreaming/_layout/finish'
    | '/_authenticated/onboarding/setup-multistreaming/_layout/success'
    | '/_authenticated/onboarding/_ensure-version/auto-determine-flow/'
    | '/_authenticated/onboarding/setup-multistreaming/_layout/'
    | '/_authenticated/settings/_layout/$canvasId/'
    | '/_authenticated/settings/_layout/broadcast-settings/'
    | '/_authenticated/settings/_layout/outputs-settings/'
    | '/_authenticated/settings/_layout/create-first-canvas/'
    | '/_authenticated/canvases/$canvasId/new/scene/'
    | '/_authenticated/onboarding/new-setup/_layout/setup-alerts/'
    | '/_authenticated/onboarding/new-setup/_layout/setup-complete/'
    | '/_authenticated/onboarding/new-setup/_layout/setup-display-capture/'
    | '/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ExceptionEventIdRoute: typeof ExceptionEventIdRoute
  ExceptionNotifyRoute: typeof ExceptionNotifyRoute
  SelectOutputYoutubeRoute: typeof SelectOutputYoutubeRoute
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  ObsModulesWarningIndexLazyRoute: typeof ObsModulesWarningIndexLazyRoute
  AuthProviderErrorRoute: typeof AuthProviderErrorRoute
  AuthProviderPreAuthRoute: typeof AuthProviderPreAuthRoute
  AuthProviderSuccessRoute: typeof AuthProviderSuccessRoute
  AuthTiktokCallbackRoute: typeof AuthTiktokCallbackRoute
  AuthTiktokCreatorIneligibilityNoticeRoute: typeof AuthTiktokCreatorIneligibilityNoticeRoute
  AuthTwitchCallbackRoute: typeof AuthTwitchCallbackRoute
  AuthConnectProviderCallbackRoute: typeof AuthConnectProviderCallbackRoute
  AuthConnectProviderPreAuthRoute: typeof AuthConnectProviderPreAuthRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ExceptionEventIdRoute: ExceptionEventIdRoute,
  ExceptionNotifyRoute: ExceptionNotifyRoute,
  SelectOutputYoutubeRoute: SelectOutputYoutubeRoute,
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  ObsModulesWarningIndexLazyRoute: ObsModulesWarningIndexLazyRoute,
  AuthProviderErrorRoute: AuthProviderErrorRoute,
  AuthProviderPreAuthRoute: AuthProviderPreAuthRoute,
  AuthProviderSuccessRoute: AuthProviderSuccessRoute,
  AuthTiktokCallbackRoute: AuthTiktokCallbackRoute,
  AuthTiktokCreatorIneligibilityNoticeRoute:
    AuthTiktokCreatorIneligibilityNoticeRoute,
  AuthTwitchCallbackRoute: AuthTwitchCallbackRoute,
  AuthConnectProviderCallbackRoute: AuthConnectProviderCallbackRoute,
  AuthConnectProviderPreAuthRoute: AuthConnectProviderPreAuthRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/exception/$eventId",
        "/exception/notify",
        "/select-output/youtube",
        "/auth/login",
        "/obs-modules-warning/",
        "/auth/$provider/error",
        "/auth/$provider/pre-auth",
        "/auth/$provider/success",
        "/auth/tiktok/callback",
        "/auth/tiktok/creator-ineligibility-notice",
        "/auth/twitch/callback",
        "/auth/connect/$provider/callback",
        "/auth/connect/$provider/pre-auth"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/",
        "/_authenticated/onboarding/getting-started",
        "/_authenticated/canvases/new",
        "/_authenticated/onboarding",
        "/_authenticated/settings",
        "/_authenticated/add-output/",
        "/_authenticated/canvases/$canvasId/remove",
        "/_authenticated/canvases/$canvasId/",
        "/_authenticated/canvases/$canvasId/$sceneId/remove",
        "/_authenticated/canvases/$canvasId/new/scene/",
        "/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass"
      ]
    },
    "/_authenticated/": {
      "filePath": "_authenticated.index/route.tsx",
      "parent": "/_authenticated"
    },
    "/exception/$eventId": {
      "filePath": "exception/$eventId.tsx"
    },
    "/exception/notify": {
      "filePath": "exception/notify.tsx"
    },
    "/select-output/youtube": {
      "filePath": "select-output/youtube.tsx"
    },
    "/auth/login": {
      "filePath": "auth/login.lazy.tsx"
    },
    "/obs-modules-warning/": {
      "filePath": "obs-modules-warning/index.lazy.tsx"
    },
    "/_authenticated/onboarding/getting-started": {
      "filePath": "_authenticated.onboarding/getting-started/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/canvases/new": {
      "filePath": "_authenticated.canvases/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding": {
      "filePath": "_authenticated.onboarding",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/onboarding/_ensure-version",
        "/_authenticated/onboarding/new-setup",
        "/_authenticated/onboarding/setup-multistreaming"
      ]
    },
    "/_authenticated/onboarding/_ensure-version": {
      "filePath": "_authenticated.onboarding/_ensure-version.tsx",
      "parent": "/_authenticated/onboarding",
      "children": [
        "/_authenticated/onboarding/_ensure-version/",
        "/_authenticated/onboarding/_ensure-version/auto-determine-flow/"
      ]
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated.settings",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/_layout"
      ]
    },
    "/_authenticated/settings/_layout": {
      "filePath": "_authenticated.settings/_layout.tsx",
      "parent": "/_authenticated/settings",
      "children": [
        "/_authenticated/settings/_layout/$canvasId/",
        "/_authenticated/settings/_layout/broadcast-settings/",
        "/_authenticated/settings/_layout/outputs-settings/",
        "/_authenticated/settings/_layout/create-first-canvas/"
      ]
    },
    "/auth/$provider/error": {
      "filePath": "auth/$provider.error.tsx"
    },
    "/auth/$provider/pre-auth": {
      "filePath": "auth/$provider.pre-auth.tsx"
    },
    "/auth/$provider/success": {
      "filePath": "auth/$provider.success.tsx"
    },
    "/auth/tiktok/callback": {
      "filePath": "auth/tiktok/callback.tsx"
    },
    "/auth/tiktok/creator-ineligibility-notice": {
      "filePath": "auth/tiktok/creator-ineligibility-notice.tsx"
    },
    "/auth/twitch/callback": {
      "filePath": "auth/twitch/callback.tsx"
    },
    "/_authenticated/add-output/": {
      "filePath": "_authenticated.add-output/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding/_ensure-version/": {
      "filePath": "_authenticated.onboarding/_ensure-version.index/route.tsx",
      "parent": "/_authenticated/onboarding/_ensure-version"
    },
    "/_authenticated/canvases/$canvasId/remove": {
      "filePath": "_authenticated.canvases/$canvasId/remove/route.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding/new-setup": {
      "filePath": "_authenticated.onboarding/new-setup",
      "parent": "/_authenticated/onboarding",
      "children": [
        "/_authenticated/onboarding/new-setup/_layout"
      ]
    },
    "/_authenticated/onboarding/new-setup/_layout": {
      "filePath": "_authenticated.onboarding/new-setup/_layout.tsx",
      "parent": "/_authenticated/onboarding/new-setup",
      "children": [
        "/_authenticated/onboarding/new-setup/_layout/",
        "/_authenticated/onboarding/new-setup/_layout/setup-alerts/",
        "/_authenticated/onboarding/new-setup/_layout/setup-complete/",
        "/_authenticated/onboarding/new-setup/_layout/setup-display-capture/"
      ]
    },
    "/_authenticated/onboarding/setup-multistreaming": {
      "filePath": "_authenticated.onboarding/setup-multistreaming",
      "parent": "/_authenticated/onboarding",
      "children": [
        "/_authenticated/onboarding/setup-multistreaming/_layout"
      ]
    },
    "/_authenticated/onboarding/setup-multistreaming/_layout": {
      "filePath": "_authenticated.onboarding/setup-multistreaming/_layout.tsx",
      "parent": "/_authenticated/onboarding/setup-multistreaming",
      "children": [
        "/_authenticated/onboarding/setup-multistreaming/_layout/connect",
        "/_authenticated/onboarding/setup-multistreaming/_layout/finish",
        "/_authenticated/onboarding/setup-multistreaming/_layout/success",
        "/_authenticated/onboarding/setup-multistreaming/_layout/"
      ]
    },
    "/auth/connect/$provider/callback": {
      "filePath": "auth/connect/$provider.callback.tsx"
    },
    "/auth/connect/$provider/pre-auth": {
      "filePath": "auth/connect/$provider.pre-auth.tsx"
    },
    "/_authenticated/canvases/$canvasId/": {
      "filePath": "_authenticated.canvases/$canvasId/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding/new-setup/_layout/": {
      "filePath": "_authenticated.onboarding/new-setup/_layout.index/route.tsx",
      "parent": "/_authenticated/onboarding/new-setup/_layout"
    },
    "/_authenticated/canvases/$canvasId/$sceneId/remove": {
      "filePath": "_authenticated.canvases/$canvasId/$sceneId.remove.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding/setup-multistreaming/_layout/connect": {
      "filePath": "_authenticated.onboarding/setup-multistreaming/_layout.connect.tsx",
      "parent": "/_authenticated/onboarding/setup-multistreaming/_layout"
    },
    "/_authenticated/onboarding/setup-multistreaming/_layout/finish": {
      "filePath": "_authenticated.onboarding/setup-multistreaming/_layout.finish.tsx",
      "parent": "/_authenticated/onboarding/setup-multistreaming/_layout"
    },
    "/_authenticated/onboarding/setup-multistreaming/_layout/success": {
      "filePath": "_authenticated.onboarding/setup-multistreaming/_layout.success.tsx",
      "parent": "/_authenticated/onboarding/setup-multistreaming/_layout"
    },
    "/_authenticated/onboarding/_ensure-version/auto-determine-flow/": {
      "filePath": "_authenticated.onboarding/_ensure-version.auto-determine-flow/index.tsx",
      "parent": "/_authenticated/onboarding/_ensure-version"
    },
    "/_authenticated/onboarding/setup-multistreaming/_layout/": {
      "filePath": "_authenticated.onboarding/setup-multistreaming/_layout.index.tsx",
      "parent": "/_authenticated/onboarding/setup-multistreaming/_layout"
    },
    "/_authenticated/settings/_layout/$canvasId/": {
      "filePath": "_authenticated.settings._layout.$canvasId/index.tsx",
      "parent": "/_authenticated/settings/_layout"
    },
    "/_authenticated/settings/_layout/broadcast-settings/": {
      "filePath": "_authenticated.settings._layout.broadcast-settings/index.tsx",
      "parent": "/_authenticated/settings/_layout"
    },
    "/_authenticated/settings/_layout/outputs-settings/": {
      "filePath": "_authenticated.settings._layout.outputs-settings/index.tsx",
      "parent": "/_authenticated/settings/_layout"
    },
    "/_authenticated/settings/_layout/create-first-canvas/": {
      "filePath": "_authenticated.settings._layout.create-first-canvas/index.lazy.tsx",
      "parent": "/_authenticated/settings/_layout"
    },
    "/_authenticated/canvases/$canvasId/new/scene/": {
      "filePath": "_authenticated.canvases/$canvasId/new/scene/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/onboarding/new-setup/_layout/setup-alerts/": {
      "filePath": "_authenticated.onboarding/new-setup/_layout.setup-alerts/index.tsx",
      "parent": "/_authenticated/onboarding/new-setup/_layout"
    },
    "/_authenticated/onboarding/new-setup/_layout/setup-complete/": {
      "filePath": "_authenticated.onboarding/new-setup/_layout.setup-complete/index.tsx",
      "parent": "/_authenticated/onboarding/new-setup/_layout"
    },
    "/_authenticated/onboarding/new-setup/_layout/setup-display-capture/": {
      "filePath": "_authenticated.onboarding/new-setup/_layout.setup-display-capture/index.tsx",
      "parent": "/_authenticated/onboarding/new-setup/_layout"
    },
    "/_authenticated/canvases/$canvasId/new/source/$sceneId/$sourceClass": {
      "filePath": "_authenticated.canvases/$canvasId/new/source/$sceneId.$sourceClass.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
